import React from 'react';
import classNames from 'classnames';
import CustomizationFiltersItem from './CustomizationFiltersItem';

const CustomizationFilters = React.forwardRef(function CustomizationFilters(
  { filters, setFilter, customState, isNew = false },
  ref,
) {
  return (
    <>
      <div
        className={classNames(`customization__filters customization__filters_${customState}`, {
          customization__filters_odd: filters.length % 2 === 1,
          customization__filters_full: filters.length < 2,
        })}
      >
        {filters.map((el, id) => (
          <CustomizationFiltersItem
            key={`b-${id}`}
            customState={customState}
            isNew={isNew}
            setFilter={setFilter}
            index={id}
            {...el}
          />
        ))}
      </div>
    </>
  );
});
export default CustomizationFilters;
CustomizationFilters.propTypes = {};
